import { z } from "zod";
const slugSchema = z.string().trim().min(2).max(80).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/);
const hotelCodeSchema = z.string().trim().min(1).max(24).regex(/^[A-Za-z0-9_-]+$/);
export const provisionPlatformAccountSchema = z.object({
    externalOrganizationId: z.string().min(1).max(128),
    organization: z.object({
        name: z.string().trim().min(2).max(160),
        slug: slugSchema,
        defaultTimezone: z.string().trim().min(1).max(64)
    }).strict(),
    hotel: z.object({
        name: z.string().trim().min(2).max(160),
        code: hotelCodeSchema,
        timezone: z.string().trim().min(1).max(64)
    }).strict(),
    administrator: z.object({
        email: z.string().trim().toLowerCase().email().max(254),
        fullName: z.string().trim().min(2).max(160)
    }).strict()
}).strict();
export const platformAccountProvisioningResponseSchema = z.object({
    sourceSystem: z.literal("TEMELJ_KONTE"),
    externalOrganizationId: z.string().min(1).max(128),
    organization: z.object({
        id: z.string().uuid(),
        name: z.string().min(1),
        slug: z.string().min(1)
    }).strict(),
    hotel: z.object({
        id: z.string().uuid(),
        name: z.string().min(1),
        code: z.string().min(1)
    }).strict(),
    administratorInvitation: z.object({
        id: z.string().uuid(),
        email: z.string().email(),
        status: z.literal("PENDING"),
        expiresAt: z.string().datetime()
    }).strict(),
    provisionedAt: z.string().datetime(),
    replayed: z.boolean()
}).strict();
